import React from 'react';
import { FilterCancelButton } from 'apps/sigma2-ui/src/filters-v2/components/FilterCancelButton';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { FilterApplyButton } from 'apps/sigma2-ui/src/filters-v2/components/FilterApplyButton';

export interface FilterButtonsProps {
  /**
   * Callback when the cancel button is clicked
   */
  onCancel: () => void;

  /**
   * Callback when the apply button is clicked
   */
  onApply: () => void;

  /**
   * The count to use for the apply button
   */
  appliedCount: number;

  /**
   * Whether or not the apply button is disabled
   */
  applyDisabled: boolean;
}

export const FilterButtons = ({
  onCancel,
  applyDisabled,
  onApply,
  appliedCount,
}: FilterButtonsProps) => {
  return (
    <Spacing direction={'horizontal'} size={''}>
      <div className={'flex-1'}>
        <FilterCancelButton onCancel={onCancel} />
      </div>
      <div className={'flex-1'}>
        <FilterApplyButton
          appliedCount={appliedCount}
          disabled={applyDisabled}
          onApply={onApply}
        />
      </div>
    </Spacing>
  );
};
